import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { BaseFormComponent } from 'src/app/utils/forms/base-form.component';
import { FormValidations } from 'src/app/utils/forms/form-validations';
import { MailUpdatePayload } from '../../models/users.model';
import { LocalStorageService } from '../../services/local-storage.service';
import { UsersService } from '../../services/users.service';

@Component({
    selector: 'app-email-form',
    templateUrl: './email-form.component.html',
    styleUrls: ['./email-form.component.scss'],
    standalone: false
})
export class EmailFormComponent extends BaseFormComponent implements OnInit {
	@Input() userId: string = '';
	completed: boolean = false;
	submitted: boolean = false;
	isPending: boolean = false;
	title: string = 'Actualizar correo';
	@Output() emailUpdated = new EventEmitter<void>();

	constructor(
		private fb: UntypedFormBuilder,
		private usersService: UsersService,
		private localStorage: LocalStorageService
	) {
		super();
	}

	ngOnInit(): void {
		this.form = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
			emailConfirmation: ['', [Validators.required, FormValidations.sameMailCheck('email'), Validators.email, Validators.maxLength(200)]],
		});
	}

	submit() {
		if (!this.form.valid) {
			this.verifyFormValidations(this.form);
		} else {
			this.isPending = true;
			this.usersService.updateEmail(this.userId, this.form.value as MailUpdatePayload).subscribe({
				next: (result: any) => {
					this.localStorage.setItem('ROD-register.user', JSON.stringify(result));
					this.usersService.setRegisterUser(result);
					this.submitted = true;
					this.title = 'CORREO ELECTRÓNICO CONFIRMADO CON ÉXITO';
				},
				error: err => {
					this.isPending = false;
				},
			});
		}
	}
}
